import { render, staticRenderFns } from "./Play_Players.vue?vue&type=template&id=0332a65f&scoped=true"
import script from "./Play_Players.vue?vue&type=script&lang=js"
export * from "./Play_Players.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0332a65f",
  null
  
)

export default component.exports